import React from 'react';
import { useActivityTimeline } from '../ActivityTimelineProvider';

interface ActivityTimelineInfiniteScrollProps {
    trigger: React.RefObject<HTMLElement> | Element | null;
}

export const ActivityTimelineInfiniteScroll: React.FC<ActivityTimelineInfiniteScrollProps> = ({ trigger }) => {
    const { page, totalPages, isLoading, loadMoreActivities } = useActivityTimeline();

    React.useEffect(() => {
        if (!trigger) {
            return;
        }

        const scrollTrigger = trigger instanceof Element ? trigger : trigger.current;

        if (!scrollTrigger) {
            return;
        }

        const scrollHandler = (event: Event) => {
            const offset = 50;

            const isScrollingToBottom =
                (event.target as HTMLElement).scrollTop + (event.target as HTMLElement).clientHeight >=
                (event.target as HTMLElement).scrollHeight - offset;

            if (isScrollingToBottom && Number(totalPages) > page && !isLoading) {
                loadMoreActivities();
            }
        };

        scrollTrigger.addEventListener('scroll', scrollHandler);

        return () => {
            scrollTrigger.removeEventListener('scroll', scrollHandler);
        };
    }, [trigger, isLoading, page, totalPages, loadMoreActivities]);

    return null;
};
